'use client';
import ProductCard from '../../miniapp/components/ProductCard';
import type { Product } from '../../miniapp/types';
import { manufacturerPath } from '../../utils/websiteSsr/paths';
import { useWebsiteAppContext } from '../hooks/useWebsiteAppContext';
import { formatCurrency } from '../utils/formatters';
import RouterLinkAdapter from './RouterLinkAdapter';
import { WEBSITE_PRODUCT_CARD_SIZES } from '../../utils/responsiveImages';

interface ProductCardIslandProps {
  product: Product;
  href: string;
  manufacturerHref?: string | undefined;
  currency: string;
  priority?: boolean;
}

export default function ProductCardIsland({
  product,
  href,
  manufacturerHref,
  currency,
  priority = false,
}: ProductCardIslandProps) {
  const { addToCart, removeFromCart, cartItems } = useWebsiteAppContext();
  const getCartQuantity = (weight: number) =>
    cartItems
      .filter((item) => item.product.id === product.id && item.weight === weight)
      .reduce((total, item) => total + item.quantity, 0);

  return (
    <ProductCard
      product={product}
      href={href}
      manufacturerHref={
        manufacturerHref ??
        (product.manufacturer ? manufacturerPath(product.manufacturer) : undefined)
      }
      LinkComponent={RouterLinkAdapter}
      priority={priority}
      imageSizes={WEBSITE_PRODUCT_CARD_SIZES}
      getCartQuantity={getCartQuantity}
      onAddToCart={(weight) => addToCart(product.id, weight)}
      onRemoveFromCart={(weight) => removeFromCart(product.id, weight)}
      formatCurrency={(value) => formatCurrency(value, currency)}
    />
  );
}
